import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
  requestId: string;
  callback: (success: boolean, code?: string) => void;
}

export interface DebtsPullingAction {
  type: string;
  payload: Fetch;
}

export default function* debtsPulling({
  payload,
}: DebtsPullingAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    const getCustomer = (state: ReducersTypes) => state.customerReducer;
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);
    const isLogged = Boolean(customer?.accessToken);

    const { apiInstance, prefixUri } = getApiConfig(isLogged);
    const response = yield call(
      apiInstance.get,
      `${prefixUri}/v1/vehicle-debts/status/${payload.requestId}`,
    );

    if (response?.data?.data?.flSituacao === 2) {
      yield call(payload.callback, true, response?.data?.data?.passagens);
    } else {
      yield call(
        payload.callback,
        false,
        response?.data?.data?.flSituacao === 3 ? "timeout" : "again",
      );
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
